import { Link } from "react-router-dom";
import { Play, Clock } from "lucide-react";

export default function ContentCard({ item }) {
  return (
    <Link
      to={`/watch/${item.id}`}
      data-testid={`content-card-${item.id}`}
      className="content-card card-shine relative flex-shrink-0 w-[260px] rounded-xl overflow-hidden border border-white/10 bg-[#121216] group"
    >
      <div className="aspect-video overflow-hidden bg-black">
        <img src={item.thumbnail} alt={item.title} className="w-full h-full object-cover group-hover:scale-110" style={{ transition: "transform 0.5s ease" }} />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-70 group-hover:opacity-90 transition-opacity" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-14 h-14 rounded-full btn-gold flex items-center justify-center">
            <Play className="w-5 h-5 ml-0.5" strokeWidth={2.5} />
          </div>
        </div>
      </div>
      <div className="p-3">
        <h4 className="font-heading text-[15px] font-semibold text-white leading-tight line-clamp-1">{item.title}</h4>
        <div className="flex items-center gap-2 mt-1.5 text-[11px] text-white/50">
          <span className="text-[#D4AF37] font-semibold">{item.rating}</span>
          <span>•</span>
          <span>{item.year}</span>
          <span>•</span>
          <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{item.duration_min}m</span>
        </div>
      </div>
    </Link>
  );
}
